import DocumentsContractorProjectsFilters from "@/entities/filters/DocumentsContractorProjectsFilters";

const documentsContractorProjectsTemplate: DocumentsContractorProjectsFilters = {
  file_name: "",
  companies: [],
  projects: [],
};

export default documentsContractorProjectsTemplate;